import axios from '@/lib/axios'
import { useMutation } from '@tanstack/vue-query'
import { request } from 'http'
import { ToastInterface, useToast } from 'vue-toastification'

interface Props {
	id: number | string
}

interface RequestCancel {
	id: number
	comment?: string
}

const cancelRequest = async (
	requestCancel: RequestCancel,
	toast: ToastInterface
) => {
	try {
		const data = await axios.delete(
			`/api/requests/${requestCancel.id}/pnrs/cancel`,
			{
				data: {
					comment: requestCancel.comment,
				},
			}
		)

		toast.success(
			'Su reserva ha sido cancelada correctamente. Se ha notificado a las partes involucradas.'
		)
	} catch (error: any) {
		toast.error(error.response.data.message)
	}
}

const useRequestCancel = (props: Props) => {
	const toast = useToast()

	const requestCancelMutation = useMutation((requestCancel: RequestCancel) =>
		cancelRequest(
			{
				id: requestCancel.id,
				comment: requestCancel.comment,
			},
			toast
		)
	)

	return {
		requestCancelMutation,
		requestCancelMutationLoading: requestCancelMutation.isLoading,
		requestCancelMutationError: requestCancelMutation.isError,
		requestCancelMutationAsync: requestCancelMutation.mutateAsync,
	}
}

export default useRequestCancel
